import gql from 'graphql-tag';

export const GET_UTILITY_INFO_FOR_BILLING = gql`
  query GetUtilityInfoForBilling($planId: Int!) {
    plan(id: $planId) {
      id
      utilityAccounts {
        id
        utility {
          id
          displayName
          url
        }
      }
    }
  }
`;

export const getUtilityInfoForBillingMock = {
  plan: {
    id: 1,
    utilityAccounts: [
      {
        id: 2,
        utility: {
          id: 3,
          displayName: 'National Grid',
          url: 'https://testing.com',
        },
      },
    ],
  },
};
